module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec04_sp_2d59bf7fbd755d2dc07ed9ab2c5eab90.jpg";